"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _AppCard = require("./AppCard.styles");

var _elements = require("../../styles/elements");

var Controls = (0, _base["default"])("div", {
  target: "e1281v9f1",
  label: "Controls"
})(_AppCard.styles.controls, ";");
var Container = (0, _base["default"])("div", {
  target: "e1281v9f0",
  label: "Container"
})(_AppCard.styles.base, ";");

var AppCard = function AppCard(_ref) {
  var title = _ref.title,
      logo = _ref.logo,
      description = _ref.description,
      installed = _ref.installed,
      className = _ref.className,
      onConfigure = _ref.onConfigure,
      onConnect = _ref.onConnect,
      connectBtnText = _ref.connectBtnText,
      hasUninstallBtn = _ref.hasUninstallBtn,
      onUninstall = _ref.onUninstall;
  var showBtn = (0, _react.useCallback)(function () {
    if (!installed) {
      return (0, _jsxRuntime.jsx)(_Button["default"], {
        size: "small",
        onClick: onConnect,
        children: connectBtnText
      });
    }

    if (hasUninstallBtn) {
      return (0, _jsxRuntime.jsx)(_Button["default"], {
        type: "warningOutline",
        size: "small",
        onClick: onUninstall,
        children: "Uninstall"
      });
    }

    return (0, _jsxRuntime.jsx)(_Button["default"], {
      type: "tertiary",
      size: "small",
      onClick: onConfigure,
      children: "Configure"
    });
  }, [connectBtnText, installed, hasUninstallBtn, onConnect, onUninstall, onConfigure]);
  return (0, _jsxRuntime.jsxs)(Container, {
    className: (0, _clsx["default"])('grui box-shadow-sm', className),
    children: [logo && (0, _jsxRuntime.jsx)("div", {
      css: _AppCard.styles.imageBox,
      children: logo
    }), (0, _jsxRuntime.jsxs)("div", {
      css: _AppCard.styles.content,
      children: [(0, _jsxRuntime.jsx)("div", {
        css: _elements.text.styles.fontMedium,
        children: title
      }), (0, _jsxRuntime.jsx)("div", {
        css: _elements.text.styles.textDark,
        children: description
      })]
    }), (0, _jsxRuntime.jsx)(Controls, {
      css: _AppCard.styles.controls,
      children: showBtn()
    })]
  });
};

AppCard.propTypes = {
  className: _propTypes.string,
  title: _propTypes.string,

  /**
   * Svg Component
   */
  logo: _propTypes.node,
  description: _propTypes.string,

  /**
   * Whether this app has been installed
   */
  installed: _propTypes.bool,

  /**
   * Handle configure
   */
  onConfigure: _propTypes.func,

  /**
   * Handle connect
   */
  onConnect: _propTypes.func,
  connectBtnText: _propTypes.string,

  /**
   * Show uninstall button intead of configure
   */
  hasUninstallBtn: _propTypes.bool,

  /**
   * handle uninstall
   */
  onUninstall: _propTypes.func
};
AppCard.defaultProps = {
  className: undefined,
  title: undefined,
  description: undefined,
  logo: undefined,
  installed: false,
  onConfigure: function onConfigure() {},
  onConnect: function onConnect() {},
  connectBtnText: 'Connect',
  hasUninstallBtn: false,
  onUninstall: function onUninstall() {}
};
var _default = AppCard;
exports["default"] = _default;
//# sourceMappingURL=AppCard.js.map